var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-row",
    {
      directives: [
        {
          name: "scroll",
          rawName: "v-scroll",
          value: _vm.onScroll,
          expression: "onScroll",
        },
      ],
    },
    [
      _c("mini-header", {
        key: _vm.resetTab,
        attrs: {
          title: "Cuadratura",
          breadcrumbs: _vm.breadcrumbs,
          hiddenTab: true,
          scroll: _vm.scroll,
        },
        scopedSlots: _vm._u(
          [
            _vm.$helpers.hasSomePermission(["view_reconciliation"])
              ? {
                  key: "main",
                  fn: function () {
                    return [
                      _c(
                        "v-btn",
                        {
                          staticClass: "mr-2",
                          attrs: {
                            outlined: "",
                            disabled: !_vm.reconciliationList?.length,
                          },
                          on: {
                            click: function ($event) {
                              ;(_vm.isLoadMore = true),
                                (_vm.isUpdate = true),
                                _vm.getList()
                            },
                          },
                        },
                        [
                          _c("v-img", {
                            attrs: {
                              contain: "",
                              src: require(`@/assets/icon-update${
                                _vm.$vuetify.theme.dark ? "-dark" : ""
                              }.svg`),
                            },
                          }),
                        ],
                        1
                      ),
                      _vm.$helpers.hasSomePermission(["add_reconciliation"])
                        ? [
                            _vm.isChile
                              ? _c(
                                  "v-menu",
                                  {
                                    attrs: {
                                      "close-on-click": "",
                                      "close-on-content-click": "",
                                      "offset-y": "",
                                      left: "",
                                      "nudge-bottom": 10,
                                      transition: "slide-y-transition",
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "activator",
                                          fn: function ({ on, attrs }) {
                                            return [
                                              _c(
                                                "v-btn",
                                                _vm._g(
                                                  _vm._b(
                                                    {
                                                      attrs: {
                                                        color: "grey-900",
                                                        ripple: false,
                                                      },
                                                    },
                                                    "v-btn",
                                                    attrs,
                                                    false
                                                  ),
                                                  on
                                                ),
                                                [
                                                  _c(
                                                    "v-icon",
                                                    { attrs: { left: "" } },
                                                    [_vm._v("mdi-plus-box")]
                                                  ),
                                                  _vm._v("Nueva cuadratura"),
                                                  _c(
                                                    "v-icon",
                                                    {
                                                      attrs: {
                                                        size: "18",
                                                        right: "",
                                                      },
                                                    },
                                                    [_vm._v("mdi-chevron-down")]
                                                  ),
                                                ],
                                                1
                                              ),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      false,
                                      1002758961
                                    ),
                                  },
                                  [
                                    _c(
                                      "v-list",
                                      { staticClass: "pa-0" },
                                      _vm._l(
                                        _vm.reconciliationTypes,
                                        function (type) {
                                          return _c(
                                            "v-list-item",
                                            {
                                              key: type.id,
                                              staticClass: "px-3",
                                              attrs: { ripple: false },
                                              on: {
                                                click: function ($event) {
                                                  return _vm.openCreateDialog(
                                                    type.id
                                                  )
                                                },
                                              },
                                            },
                                            [
                                              _c(
                                                "v-list-item-title",
                                                { staticClass: "body-2" },
                                                [_vm._v(_vm._s(type.name))]
                                              ),
                                            ],
                                            1
                                          )
                                        }
                                      ),
                                      1
                                    ),
                                  ],
                                  1
                                )
                              : _c(
                                  "v-btn",
                                  {
                                    attrs: { color: "grey-900", ripple: false },
                                    on: {
                                      click: function ($event) {
                                        return _vm.openCreateDialog()
                                      },
                                    },
                                  },
                                  [
                                    _c("v-icon", { attrs: { left: "" } }, [
                                      _vm._v("mdi-plus-box"),
                                    ]),
                                    _vm._v("Nueva cuadratura"),
                                  ],
                                  1
                                ),
                          ]
                        : _vm._e(),
                    ]
                  },
                  proxy: true,
                }
              : null,
            _vm.$helpers.hasSomePermission(["view_reconciliation"])
              ? {
                  key: "custom-tab",
                  fn: function () {
                    return [
                      _c(
                        "v-tabs",
                        {
                          staticClass: "mt-n3 pt-8 pl-4 pr-5 grey-background",
                          staticStyle: {
                            position: "absolute",
                            "z-index": "0 !important",
                          },
                          attrs: { height: 35 },
                          model: {
                            value: _vm.filter,
                            callback: function ($$v) {
                              _vm.filter = $$v
                            },
                            expression: "filter",
                          },
                        },
                        _vm._l(_vm.stepperList, function (status) {
                          return _c(
                            "v-tab",
                            { key: status.id, attrs: { ripple: false } },
                            [
                              _c("v-icon", { attrs: { left: "", small: "" } }, [
                                _vm._v("mdi-" + _vm._s(status.icon)),
                              ]),
                              _vm._v(_vm._s(status.title) + " "),
                              status.title === "Todas" ? void 0 : _vm._e(),
                            ],
                            2
                          )
                        }),
                        1
                      ),
                    ]
                  },
                  proxy: true,
                }
              : null,
          ],
          null,
          true
        ),
      }),
      _c(
        "v-col",
        { staticClass: "pa-0 mt-25" },
        [
          !_vm.$helpers.hasSomePermission(["view_reconciliation"])
            ? _c("PermissionDenied")
            : _c(
                "v-col",
                { staticClass: "px-0" },
                [
                  _vm.loading
                    ? _c("skeleton-list")
                    : [
                        _vm.reconciliationList.length
                          ? _c(
                              "v-col",
                              { staticClass: "px-0 pb-16 mb-5" },
                              [
                                _c("v-simple-table", {
                                  class: [
                                    {
                                      "fixed-table":
                                        _vm.$store.state.base
                                          .isExpandNavigationDrawer,
                                    },
                                  ],
                                  attrs: {
                                    height: _vm.heightTable,
                                    "fixed-header": "",
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function () {
                                          return [
                                            _c("VTableHeaders", {
                                              attrs: { headers: _vm.headers },
                                              on: { sort: _vm.setSort },
                                            }),
                                            _c("v-divider", {
                                              staticStyle: {
                                                position: "absolute",
                                                "margin-top": "-6px",
                                                "min-width": "100%",
                                                "margin-left": "-5px",
                                                "z-index": "2",
                                              },
                                            }),
                                            _c(
                                              "tbody",
                                              _vm._l(
                                                _vm.reconciliationList,
                                                function (item, i) {
                                                  return _c(
                                                    "tr",
                                                    {
                                                      directives: [
                                                        {
                                                          name: "intersect",
                                                          rawName:
                                                            "v-intersect",
                                                          value:
                                                            i + 1 ===
                                                            _vm
                                                              .reconciliationList
                                                              ?.length
                                                              ? _vm.loadMore
                                                              : "",
                                                          expression:
                                                            "(i + 1) === reconciliationList?.length ? loadMore : ''",
                                                        },
                                                      ],
                                                      key: i,
                                                      staticStyle: {
                                                        cursor: "pointer",
                                                      },
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          ;(_vm.currentItem =
                                                            item),
                                                            (_vm.dialogDetail = true)
                                                        },
                                                      },
                                                    },
                                                    [
                                                      _c(
                                                        "td",
                                                        {
                                                          staticClass: "body-2",
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(item.id)
                                                          ),
                                                        ]
                                                      ),
                                                      _c(
                                                        "td",
                                                        {
                                                          staticClass: "body-2",
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.reconciliationTypeName(
                                                                item.type
                                                              )
                                                            )
                                                          ),
                                                        ]
                                                      ),
                                                      _c(
                                                        "td",
                                                        {
                                                          staticClass:
                                                            "body-2 text-end",
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm._f("date")(
                                                                item.date
                                                              )
                                                            )
                                                          ),
                                                        ]
                                                      ),
                                                      _c(
                                                        "td",
                                                        [
                                                          _c(
                                                            "v-tooltip",
                                                            {
                                                              attrs: {
                                                                color:
                                                                  "white-0",
                                                                right: "",
                                                                transition:
                                                                  "scale-transition",
                                                                "max-width": 280,
                                                                "open-on-hover":
                                                                  item.status_message
                                                                    ? true
                                                                    : false,
                                                              },
                                                              scopedSlots:
                                                                _vm._u(
                                                                  [
                                                                    {
                                                                      key: "activator",
                                                                      fn: function ({
                                                                        on,
                                                                      }) {
                                                                        return [
                                                                          _c(
                                                                            "v-chip",
                                                                            _vm._g(
                                                                              {
                                                                                staticClass:
                                                                                  "scroll",
                                                                                attrs:
                                                                                  {
                                                                                    color:
                                                                                      _vm.stepperList.find(
                                                                                        ({
                                                                                          status,
                                                                                        }) =>
                                                                                          status.includes(
                                                                                            item.status
                                                                                          )
                                                                                      )
                                                                                        .color,
                                                                                    small:
                                                                                      "",
                                                                                    label:
                                                                                      "",
                                                                                  },
                                                                              },
                                                                              item.status_message
                                                                                ? on
                                                                                : false
                                                                            ),
                                                                            [
                                                                              _vm._v(
                                                                                " " +
                                                                                  _vm._s(
                                                                                    _vm.stepperList.find(
                                                                                      ({
                                                                                        status,
                                                                                      }) =>
                                                                                        status.includes(
                                                                                          item.status
                                                                                        )
                                                                                    )
                                                                                      .title
                                                                                  ) +
                                                                                  " "
                                                                              ),
                                                                              _c(
                                                                                "v-icon",
                                                                                {
                                                                                  attrs:
                                                                                    {
                                                                                      right:
                                                                                        "",
                                                                                    },
                                                                                },
                                                                                [
                                                                                  _vm._v(
                                                                                    "mdi-" +
                                                                                      _vm._s(
                                                                                        _vm.stepperList.find(
                                                                                          ({
                                                                                            status,
                                                                                          }) =>
                                                                                            status.includes(
                                                                                              item.status
                                                                                            )
                                                                                        )
                                                                                          .icon
                                                                                      )
                                                                                  ),
                                                                                ]
                                                                              ),
                                                                            ],
                                                                            1
                                                                          ),
                                                                        ]
                                                                      },
                                                                    },
                                                                  ],
                                                                  null,
                                                                  true
                                                                ),
                                                            },
                                                            [
                                                              _c(
                                                                "span",
                                                                {
                                                                  staticClass:
                                                                    "d-block px-3 py-2",
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      item.status_message
                                                                    )
                                                                  ),
                                                                ]
                                                              ),
                                                            ]
                                                          ),
                                                        ],
                                                        1
                                                      ),
                                                      _c(
                                                        "td",
                                                        {
                                                          staticClass: "body-2",
                                                        },
                                                        [
                                                          _c(
                                                            "v-tooltip",
                                                            {
                                                              attrs: {
                                                                color:
                                                                  "white-0",
                                                                right: "",
                                                                transition:
                                                                  "scale-transition",
                                                                "max-width": 280,
                                                              },
                                                              scopedSlots:
                                                                _vm._u(
                                                                  [
                                                                    {
                                                                      key: "activator",
                                                                      fn: function ({
                                                                        on,
                                                                      }) {
                                                                        return [
                                                                          _c(
                                                                            "span",
                                                                            _vm._g(
                                                                              {
                                                                                staticClass:
                                                                                  "d-inline-block text-truncate",
                                                                                staticStyle:
                                                                                  {
                                                                                    "max-width":
                                                                                      "99%",
                                                                                  },
                                                                              },
                                                                              on
                                                                            ),
                                                                            [
                                                                              _vm._v(
                                                                                _vm._s(
                                                                                  item.filename
                                                                                )
                                                                              ),
                                                                            ]
                                                                          ),
                                                                        ]
                                                                      },
                                                                    },
                                                                  ],
                                                                  null,
                                                                  true
                                                                ),
                                                            },
                                                            [
                                                              _c(
                                                                "span",
                                                                {
                                                                  staticClass:
                                                                    "d-block pa-3 grey-700--text",
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      item.filename
                                                                    )
                                                                  ),
                                                                ]
                                                              ),
                                                            ]
                                                          ),
                                                        ],
                                                        1
                                                      ),
                                                      _c(
                                                        "td",
                                                        {
                                                          staticClass:
                                                            "body-2 text-end",
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm._f(
                                                                "dateTimeSecond"
                                                              )(item.created)
                                                            )
                                                          ),
                                                        ]
                                                      ),
                                                      _c(
                                                        "td",
                                                        {
                                                          staticClass:
                                                            "body-2 text-end",
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.$fmt.integer(
                                                                item.file_count
                                                              )
                                                            )
                                                          ),
                                                        ]
                                                      ),
                                                      _c(
                                                        "td",
                                                        {
                                                          staticClass:
                                                            "body-2 text-end",
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.$fmt.integer(
                                                                item.file_count -
                                                                  item.ok_count
                                                              )
                                                            )
                                                          ),
                                                        ]
                                                      ),
                                                      _c(
                                                        "td",
                                                        {
                                                          staticClass:
                                                            "text-right",
                                                        },
                                                        [
                                                          _c(
                                                            "v-menu",
                                                            {
                                                              attrs: {
                                                                "close-on-click":
                                                                  "",
                                                                "close-on-content-click":
                                                                  "",
                                                                "offset-y": "",
                                                                left: "",
                                                                "nudge-left": 10,
                                                                "nudge-bottom": 10,
                                                                transition:
                                                                  "slide-y-transition",
                                                              },
                                                              scopedSlots:
                                                                _vm._u(
                                                                  [
                                                                    {
                                                                      key: "activator",
                                                                      fn: function ({
                                                                        on,
                                                                        attrs,
                                                                      }) {
                                                                        return [
                                                                          _c(
                                                                            "v-btn",
                                                                            _vm._g(
                                                                              _vm._b(
                                                                                {
                                                                                  staticClass:
                                                                                    "mr-n4 scroll",
                                                                                  attrs:
                                                                                    {
                                                                                      text: "",
                                                                                      "x-small":
                                                                                        "",
                                                                                    },
                                                                                  on: {
                                                                                    click:
                                                                                      function (
                                                                                        $event
                                                                                      ) {
                                                                                        _vm.current =
                                                                                          item
                                                                                      },
                                                                                  },
                                                                                },
                                                                                "v-btn",
                                                                                attrs,
                                                                                false
                                                                              ),
                                                                              on
                                                                            ),
                                                                            [
                                                                              _c(
                                                                                "v-icon",
                                                                                {
                                                                                  attrs:
                                                                                    {
                                                                                      color:
                                                                                        "grey-700",
                                                                                      size: "24",
                                                                                    },
                                                                                },
                                                                                [
                                                                                  _vm._v(
                                                                                    "mdi-dots-vertical"
                                                                                  ),
                                                                                ]
                                                                              ),
                                                                            ],
                                                                            1
                                                                          ),
                                                                        ]
                                                                      },
                                                                    },
                                                                  ],
                                                                  null,
                                                                  true
                                                                ),
                                                            },
                                                            [
                                                              _c(
                                                                "v-list",
                                                                {
                                                                  staticClass:
                                                                    "pa-0",
                                                                },
                                                                [
                                                                  !_vm.isBookType(
                                                                    item.type
                                                                  )
                                                                    ? _c(
                                                                        "v-list-item",
                                                                        {
                                                                          staticClass:
                                                                            "px-3",
                                                                          attrs:
                                                                            {
                                                                              ripple: false,
                                                                            },
                                                                          on: {
                                                                            click:
                                                                              function (
                                                                                $event
                                                                              ) {
                                                                                return _vm.download(
                                                                                  item.id,
                                                                                  item.filename
                                                                                )
                                                                              },
                                                                          },
                                                                        },
                                                                        [
                                                                          _c(
                                                                            "v-list-item-title",
                                                                            {
                                                                              staticClass:
                                                                                "body-1 grey-500--text d-flex align-center",
                                                                            },
                                                                            [
                                                                              _c(
                                                                                "v-icon",
                                                                                {
                                                                                  attrs:
                                                                                    {
                                                                                      color:
                                                                                        "grey-700",
                                                                                      size: "20",
                                                                                      left: "",
                                                                                    },
                                                                                },
                                                                                [
                                                                                  _vm._v(
                                                                                    "mdi-file-document"
                                                                                  ),
                                                                                ]
                                                                              ),
                                                                              _vm._v(
                                                                                "Exportar registros"
                                                                              ),
                                                                            ],
                                                                            1
                                                                          ),
                                                                        ],
                                                                        1
                                                                      )
                                                                    : _vm._e(),
                                                                  _vm.isBookType(
                                                                    item.type
                                                                  )
                                                                    ? [
                                                                        _c(
                                                                          "v-list-item",
                                                                          {
                                                                            staticClass:
                                                                              "px-3",
                                                                            attrs:
                                                                              {
                                                                                ripple: false,
                                                                              },
                                                                            on: {
                                                                              click:
                                                                                function (
                                                                                  $event
                                                                                ) {
                                                                                  return _vm.downloadFindings(
                                                                                    item
                                                                                  )
                                                                                },
                                                                            },
                                                                          },
                                                                          [
                                                                            _c(
                                                                              "v-list-item-title",
                                                                              {
                                                                                staticClass:
                                                                                  "body-1 grey-500--text d-flex align-center",
                                                                              },
                                                                              [
                                                                                _c(
                                                                                  "v-icon",
                                                                                  {
                                                                                    attrs:
                                                                                      {
                                                                                        color:
                                                                                          "grey-700",
                                                                                        size: "20",
                                                                                        left: "",
                                                                                      },
                                                                                  },
                                                                                  [
                                                                                    _vm._v(
                                                                                      "mdi-file-delimited"
                                                                                    ),
                                                                                  ]
                                                                                ),
                                                                                _vm._v(
                                                                                  "Descargar hallazgos (CSV)"
                                                                                ),
                                                                              ],
                                                                              1
                                                                            ),
                                                                          ],
                                                                          1
                                                                        ),
                                                                        _c(
                                                                          "v-list-item",
                                                                          {
                                                                            staticClass:
                                                                              "px-3",
                                                                            attrs:
                                                                              {
                                                                                ripple: false,
                                                                              },
                                                                            on: {
                                                                              click:
                                                                                function (
                                                                                  $event
                                                                                ) {
                                                                                  return _vm.downloadSourceFile(
                                                                                    item
                                                                                  )
                                                                                },
                                                                            },
                                                                          },
                                                                          [
                                                                            _c(
                                                                              "v-list-item-title",
                                                                              {
                                                                                staticClass:
                                                                                  "body-1 grey-500--text d-flex align-center",
                                                                              },
                                                                              [
                                                                                _c(
                                                                                  "v-icon",
                                                                                  {
                                                                                    attrs:
                                                                                      {
                                                                                        color:
                                                                                          "grey-700",
                                                                                        size: "20",
                                                                                        left: "",
                                                                                      },
                                                                                  },
                                                                                  [
                                                                                    _vm._v(
                                                                                      "mdi-file-download"
                                                                                    ),
                                                                                  ]
                                                                                ),
                                                                                _vm._v(
                                                                                  "Descargar archivo original"
                                                                                ),
                                                                              ],
                                                                              1
                                                                            ),
                                                                          ],
                                                                          1
                                                                        ),
                                                                      ]
                                                                    : _vm._e(),
                                                                ],
                                                                2
                                                              ),
                                                            ],
                                                            1
                                                          ),
                                                        ],
                                                        1
                                                      ),
                                                    ]
                                                  )
                                                }
                                              ),
                                              0
                                            ),
                                          ]
                                        },
                                        proxy: true,
                                      },
                                    ],
                                    null,
                                    false,
                                    223116404
                                  ),
                                }),
                              ],
                              1
                            )
                          : (!_vm.reconciliationList?.length &&
                              !_vm.$route.query.ref) ||
                            (!_vm.reconciliationList?.length &&
                              _vm.$route.query.ref) ||
                            !_vm.reconciliationList?.length
                          ? _c("v-empty-state", {
                              attrs: {
                                title: "No existen cuadraturas para mostrar",
                                isFree: !(_vm.hiddenBtnEmpty && _vm.isCreated),
                                hiddenDescription:
                                  _vm.hiddenBtnEmpty && _vm.isCreated,
                                type: "documents",
                                id: "cuadraturas",
                                height: 220,
                                customClass: "mt-1",
                              },
                              scopedSlots: _vm._u([
                                {
                                  key: "actions",
                                  fn: function () {
                                    return [
                                      _vm.hiddenBtnEmpty && _vm.isCreated
                                        ? [
                                            _c(
                                              "v-btn",
                                              {
                                                staticClass: "ml-2",
                                                attrs: {
                                                  outlined: "",
                                                  ripple: false,
                                                  width: "153",
                                                },
                                                on: {
                                                  click: function ($event) {
                                                    _vm.$router.push({
                                                      query: { ref: "initial" },
                                                    }),
                                                      (_vm.isCreated = false)
                                                  },
                                                },
                                              },
                                              [
                                                _c(
                                                  "v-icon",
                                                  { staticClass: "mr-2" },
                                                  [
                                                    _vm._v(
                                                      "mdi-text-search-variant"
                                                    ),
                                                  ]
                                                ),
                                                _vm._v("Últimos registros"),
                                              ],
                                              1
                                            ),
                                          ]
                                        : _vm._e(),
                                    ]
                                  },
                                  proxy: true,
                                },
                              ]),
                            })
                          : _vm._e(),
                      ],
                ],
                2
              ),
        ],
        1
      ),
      _c(
        "v-dialog",
        {
          attrs: {
            width: _vm.widthModalCreateErrors,
            persistent: "",
            "no-click-animation": "",
          },
          model: {
            value: _vm.dialogCreate,
            callback: function ($$v) {
              _vm.dialogCreate = $$v
            },
            expression: "dialogCreate",
          },
        },
        [
          _c(
            "v-card",
            [
              _c(
                "v-card-title",
                { staticClass: "pa-0" },
                [
                  _c(
                    "v-toolbar",
                    {
                      staticClass: "transparent",
                      attrs: { flat: "", height: "46" },
                    },
                    [
                      _c(
                        "v-toolbar-title",
                        {
                          staticClass:
                            "px-5 subtitle-2 grey-700--text font-weight-semibold",
                        },
                        [_vm._v("Cargar cuadratura")]
                      ),
                      _c("v-spacer"),
                      _c(
                        "v-toolbar-items",
                        [
                          _c(
                            "v-row",
                            {
                              staticClass: "mr-3",
                              attrs: { align: "center", justify: "center" },
                            },
                            [
                              _c(
                                "v-btn",
                                {
                                  attrs: {
                                    icon: "",
                                    small: "",
                                    "retain-focus-on-click": "",
                                  },
                                  on: {
                                    click: function ($event) {
                                      ;(_vm.dialogCreate = false),
                                        (_vm.errors = []),
                                        _vm.clearInput()
                                    },
                                  },
                                },
                                [
                                  _c(
                                    "v-icon",
                                    {
                                      attrs: { color: "grey-500", size: "20" },
                                    },
                                    [_vm._v("mdi-close")]
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c("v-divider"),
              _c(
                "v-card-text",
                { staticClass: "pl-5 py-4" },
                [
                  _c(
                    "v-row",
                    { staticClass: "pt-2 pb-2", attrs: { align: "center" } },
                    [
                      _c("v-col", { attrs: { cols: "3" } }, [
                        _c("img", {
                          attrs: {
                            src: require(`@/assets/backgrounds/modal-folios-upload.svg`),
                            height: 178,
                          },
                        }),
                      ]),
                      _c(
                        "v-col",
                        { staticClass: "pr-0 pl-10" },
                        [
                          _c(
                            "v-list",
                            { staticClass: "v-list-form pa-0 transparent" },
                            [
                              _c(
                                "v-list-item",
                                { staticClass: "py-0" },
                                [
                                  _c(
                                    "v-list-item-title",
                                    { staticClass: "d-flex align-center" },
                                    [
                                      _vm._v("Archivo "),
                                      _c(
                                        "v-tooltip",
                                        {
                                          attrs: {
                                            color: "grey-background",
                                            right: "",
                                            "max-width": "250px",
                                            transition: "scale-transition",
                                          },
                                          scopedSlots: _vm._u([
                                            {
                                              key: "activator",
                                              fn: function ({ on }) {
                                                return [
                                                  _c(
                                                    "v-icon",
                                                    _vm._g(
                                                      {
                                                        attrs: {
                                                          right: "",
                                                          small: "",
                                                          color: "grey-700",
                                                        },
                                                      },
                                                      on
                                                    ),
                                                    [_vm._v("mdi-information")]
                                                  ),
                                                ]
                                              },
                                            },
                                          ]),
                                        },
                                        [
                                          _c(
                                            "span",
                                            {
                                              staticClass: "d-block px-3 py-2",
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(_vm.currentType.fileHint)
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "v-list-item-subtitle",
                                    { staticClass: "ml-n12" },
                                    [
                                      _c("v-file-input", {
                                        ref: "file",
                                        attrs: {
                                          error: _vm.errorFile,
                                          type: "file",
                                          accept: ".zip, .txt, .csv",
                                          prepend: "mdi-paper-clip",
                                          "hide-details": "",
                                          "background-color": "transparent",
                                          placeholder:
                                            "No se eligió ningún archivo",
                                          solo: "",
                                          flat: "",
                                          chips: "",
                                          dense: "",
                                        },
                                        on: {
                                          change: function ($event) {
                                            return _vm.setUploadFile()
                                          },
                                        },
                                        model: {
                                          value: _vm.file,
                                          callback: function ($$v) {
                                            _vm.file = $$v
                                          },
                                          expression: "file",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _c(
                                "v-list-item",
                                { staticClass: "mt-1" },
                                [
                                  _c(
                                    "v-list-item-title",
                                    { staticClass: "d-flex align-center" },
                                    [_vm._v(_vm._s(_vm.currentType.dateLabel))]
                                  ),
                                  _c(
                                    "v-list-item-subtitle",
                                    { staticClass: "ml-n8 pr-2" },
                                    [
                                      _c(
                                        "v-menu",
                                        {
                                          attrs: {
                                            "close-on-content-click": false,
                                            "offset-y": "",
                                            "nudge-bottom": 10,
                                            transition: "slide-y-transition",
                                            "max-width": "290",
                                          },
                                          scopedSlots: _vm._u([
                                            {
                                              key: "activator",
                                              fn: function ({ on, attrs }) {
                                                return [
                                                  _c(
                                                    "v-text-field",
                                                    _vm._g(
                                                      _vm._b(
                                                        {
                                                          attrs: {
                                                            error:
                                                              _vm.$v
                                                                .newReconcialiation
                                                                .date.$error,
                                                            "append-icon":
                                                              "mdi-calendar-month",
                                                            outlined: "",
                                                            "single-line": "",
                                                            dense: "",
                                                            readonly: "",
                                                            "hide-details": "",
                                                          },
                                                          model: {
                                                            value:
                                                              _vm.$v
                                                                .newReconcialiation
                                                                .date.$model,
                                                            callback: function (
                                                              $$v
                                                            ) {
                                                              _vm.$set(
                                                                _vm.$v
                                                                  .newReconcialiation
                                                                  .date,
                                                                "$model",
                                                                $$v
                                                              )
                                                            },
                                                            expression:
                                                              "$v.newReconcialiation.date.$model",
                                                          },
                                                        },
                                                        "v-text-field",
                                                        attrs,
                                                        false
                                                      ),
                                                      on
                                                    )
                                                  ),
                                                ]
                                              },
                                            },
                                          ]),
                                          model: {
                                            value: _vm.dateMenu,
                                            callback: function ($$v) {
                                              _vm.dateMenu = $$v
                                            },
                                            expression: "dateMenu",
                                          },
                                        },
                                        [
                                          _c(
                                            "v-date-picker",
                                            {
                                              key: _vm.currentType.id,
                                              attrs: {
                                                min: _vm.currentType.dateMin,
                                                "no-title": "",
                                                "first-day-of-week": 1,
                                                type: _vm.currentType
                                                  .datePicker,
                                                locale: "es",
                                                "max-width": "270",
                                                color: "grey-900",
                                              },
                                              on: {
                                                input: function ($event) {
                                                  _vm.dateMenu = false
                                                },
                                              },
                                              model: {
                                                value:
                                                  _vm.$v.newReconcialiation.date
                                                    .$model,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.$v.newReconcialiation
                                                      .date,
                                                    "$model",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "$v.newReconcialiation.date.$model",
                                              },
                                            },
                                            [
                                              _c(
                                                "v-row",
                                                {
                                                  staticClass: "mb-2 px-6",
                                                  attrs: {
                                                    align: "center",
                                                    justify: "end",
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "v-btn",
                                                    {
                                                      staticClass: "body-1",
                                                      attrs: {
                                                        ripple: false,
                                                        text: "",
                                                        color: "grey-900",
                                                      },
                                                      on: {
                                                        click: () => {
                                                          _vm.newReconcialiation.date =
                                                            null
                                                          _vm.dateMenu = false
                                                        },
                                                      },
                                                    },
                                                    [_vm._v("Limpiar")]
                                                  ),
                                                  _c("v-spacer"),
                                                  _vm.currentType.datePicker ===
                                                  "date"
                                                    ? _c(
                                                        "v-btn",
                                                        {
                                                          attrs: {
                                                            color: "grey-900",
                                                          },
                                                          on: {
                                                            click: () => {
                                                              _vm.$v.newReconcialiation.date.$model =
                                                                _vm.today
                                                              _vm.dateMenu = false
                                                            },
                                                          },
                                                        },
                                                        [_vm._v("Hoy")]
                                                      )
                                                    : _vm._e(),
                                                ],
                                                1
                                              ),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c("v-divider"),
              _c(
                "v-card-actions",
                { staticClass: "py-4 px-5" },
                [
                  _c("v-spacer"),
                  !_vm.errors.length
                    ? _c(
                        "v-btn",
                        {
                          attrs: { outlined: "", color: "grey-700" },
                          on: {
                            click: function ($event) {
                              ;(_vm.dialogCreate = false), _vm.clearInput()
                            },
                          },
                        },
                        [_vm._v("Cancelar")]
                      )
                    : _vm._e(),
                  _vm.errors.length
                    ? _c(
                        "v-btn",
                        {
                          attrs: { outlined: "", color: "grey-700" },
                          on: {
                            click: function ($event) {
                              ;(_vm.errors = []), _vm.clearInput()
                            },
                          },
                        },
                        [_vm._v("Volver a subir")]
                      )
                    : _vm._e(),
                  _c(
                    "v-btn",
                    {
                      attrs: {
                        loading: !_vm.errors.length
                          ? _vm.$store.state.reconciliations.createLoader
                          : false,
                        disabled:
                          !!_vm.errorFile ||
                          (!((_vm.file || {}).name || "").length &&
                            !!_vm.newReconcialiation.date),
                        color: "grey-900",
                      },
                      on: {
                        click: function ($event) {
                          !_vm.errors.length
                            ? _vm.createReconciliation()
                            : _vm.handleDialog()
                        },
                      },
                    },
                    [_vm._v("Continuar")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "v-dialog",
        {
          attrs: { width: 630, persistent: "", "no-click-animation": "" },
          model: {
            value: _vm.dialogDetail,
            callback: function ($$v) {
              _vm.dialogDetail = $$v
            },
            expression: "dialogDetail",
          },
        },
        [
          _c(
            "v-card",
            [
              _c(
                "v-card-title",
                { staticClass: "pa-0" },
                [
                  _c(
                    "v-toolbar",
                    {
                      staticClass: "transparent",
                      attrs: { flat: "", height: "46" },
                    },
                    [
                      _c(
                        "v-toolbar-title",
                        {
                          staticClass:
                            "px-5 subtitle-2 grey-700--text font-weight-semibold",
                        },
                        [_vm._v("Detalle del estado")]
                      ),
                      _c("v-spacer"),
                      _c(
                        "v-toolbar-items",
                        [
                          _c(
                            "v-row",
                            {
                              staticClass: "mr-3",
                              attrs: { align: "center", justify: "center" },
                            },
                            [
                              _c(
                                "v-btn",
                                {
                                  attrs: {
                                    icon: "",
                                    small: "",
                                    "retain-focus-on-click": "",
                                  },
                                  on: {
                                    click: function ($event) {
                                      _vm.dialogDetail = false
                                    },
                                  },
                                },
                                [
                                  _c(
                                    "v-icon",
                                    {
                                      attrs: { color: "grey-500", size: "20" },
                                    },
                                    [_vm._v("mdi-close")]
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c("v-divider"),
              _c(
                "v-card-text",
                { staticClass: "py-2 px-0" },
                [
                  _c(
                    "v-card",
                    { staticClass: "green-900 pt-6 pb-7 mb-5 mx-5" },
                    [
                      _c(
                        "span",
                        {
                          staticClass:
                            "px-4 subtitle-1 white--text font-weight-bold d-inline-block text-truncate",
                          staticStyle: { "max-width": "98%" },
                        },
                        [_vm._v(" " + _vm._s(_vm.currentItem.filename) + " ")]
                      ),
                      _c(
                        "span",
                        {
                          staticClass:
                            "px-4 mt-n1 subtitle-2 white--text d-block",
                        },
                        [_vm._v(_vm._s(_vm.currentItem.id))]
                      ),
                      _c(
                        "v-row",
                        {
                          staticClass: "ml-2 mt-6",
                          attrs: { align: "end", "no-gutters": "" },
                        },
                        [
                          _c("v-col", { staticClass: "py-0 px-2" }, [
                            _c(
                              "span",
                              { staticClass: "d-block body-1 white--text" },
                              [_vm._v("Fecha de cuadratura")]
                            ),
                            _c(
                              "span",
                              { staticClass: "subtitle-2 white--text" },
                              [
                                _vm.currentItem.date
                                  ? _c(
                                      "span",
                                      { staticClass: "font-weight-bold" },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm._f("date")(_vm.currentItem.date)
                                          )
                                        ),
                                      ]
                                    )
                                  : _c(
                                      "span",
                                      {
                                        staticClass: "body-2 dark font-italic",
                                      },
                                      [_vm._v("Sin especificar")]
                                    ),
                              ]
                            ),
                          ]),
                          _c("v-col", { staticClass: "py-0 px-2" }, [
                            _c(
                              "span",
                              { staticClass: "d-block body-1 white--text" },
                              [_vm._v("Fecha de creación")]
                            ),
                            _c(
                              "span",
                              { staticClass: "subtitle-2 white--text" },
                              [
                                _vm.currentItem.created
                                  ? _c(
                                      "span",
                                      { staticClass: "font-weight-bold" },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm._f("dateTimeSecond")(
                                              _vm.currentItem.created
                                            )
                                          )
                                        ),
                                      ]
                                    )
                                  : _c(
                                      "span",
                                      {
                                        staticClass: "body-2 dark font-italic",
                                      },
                                      [_vm._v("Sin especificar")]
                                    ),
                              ]
                            ),
                          ]),
                          _c("v-col", { staticClass: "py-0 px-2" }, [
                            _c(
                              "span",
                              { staticClass: "d-block body-1 white--text" },
                              [_vm._v("Fecha de actualización")]
                            ),
                            _c(
                              "span",
                              { staticClass: "subtitle-2 white--text" },
                              [
                                _vm.currentItem.updated
                                  ? _c(
                                      "span",
                                      { staticClass: "font-weight-bold" },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm._f("dateTimeSecond")(
                                              _vm.currentItem.updated
                                            )
                                          )
                                        ),
                                      ]
                                    )
                                  : _c(
                                      "span",
                                      {
                                        staticClass: "body-2 dark font-italic",
                                      },
                                      [_vm._v("Sin especificar")]
                                    ),
                              ]
                            ),
                          ]),
                        ],
                        1
                      ),
                      _c(
                        "v-row",
                        {
                          staticClass: "ml-2 mt-6",
                          attrs: { align: "end", "no-gutters": "" },
                        },
                        [
                          _c(
                            "v-col",
                            { staticClass: "py-0 px-2", attrs: { cols: "4" } },
                            [
                              _c(
                                "span",
                                { staticClass: "d-block body-1 white--text" },
                                [_vm._v("Estado")]
                              ),
                              _c(
                                "v-chip",
                                {
                                  staticClass: "scroll",
                                  attrs: {
                                    color: _vm.stepperList.find(({ status }) =>
                                      status.includes(_vm.currentItem.status)
                                    )?.color,
                                    small: "",
                                    label: "",
                                  },
                                },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.stepperList.find(({ status }) =>
                                          status.includes(
                                            _vm.currentItem.status
                                          )
                                        )?.title
                                      ) +
                                      " "
                                  ),
                                  _c("v-icon", { attrs: { right: "" } }, [
                                    _vm._v(
                                      "mdi-" +
                                        _vm._s(
                                          _vm.stepperList.find(({ status }) =>
                                            status.includes(
                                              _vm.currentItem.status
                                            )
                                          )?.icon
                                        )
                                    ),
                                  ]),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c("v-col", { staticClass: "py-0 px-2" }, [
                            _c(
                              "span",
                              { staticClass: "d-block body-1 white--text" },
                              [_vm._v("Detalle del estado")]
                            ),
                            _c(
                              "span",
                              { staticClass: "subtitle-2 white--text" },
                              [
                                _vm.currentItem.status_info
                                  ? _c(
                                      "span",
                                      { staticClass: "font-weight-bold" },
                                      [
                                        _vm._v(
                                          _vm._s(_vm.currentItem.status_info)
                                        ),
                                      ]
                                    )
                                  : _c(
                                      "span",
                                      {
                                        staticClass: "body-2 dark font-italic",
                                      },
                                      [_vm._v("Sin especificar")]
                                    ),
                              ]
                            ),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c("v-divider"),
                  _c(
                    "v-col",
                    { staticClass: "pl-5 pr-6" },
                    [
                      _c(
                        "span",
                        {
                          staticClass:
                            "d-block mt-3 grey-700--text subtitle-2 font-weight-semibold",
                        },
                        [_vm._v("Total de documentos")]
                      ),
                      _c(
                        "v-row",
                        [
                          _c("v-col", { staticClass: "px-3 mt-2" }, [
                            _c(
                              "span",
                              { staticClass: "mr-1 text-h4 grey-700--text" },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.$fmt.integer(_vm.currentItem.file_count)
                                  )
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "span",
                              { staticClass: "body-1 grey-700--text" },
                              [_vm._v("documentos cargados")]
                            ),
                            _c(
                              "div",
                              { staticClass: "mt-2 d-flex align-center" },
                              [
                                _c("v-avatar", {
                                  staticClass: "mr-1",
                                  attrs: { color: "grey-900", size: "12" },
                                }),
                                _c(
                                  "span",
                                  {
                                    staticClass: "mx-2 text-h6 grey-700--text",
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$fmt.integer(
                                          _vm.currentItem.ok_count
                                        )
                                      )
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "span",
                                  { staticClass: "body-1 grey-700--text" },
                                  [_vm._v("cuadrados OK")]
                                ),
                              ],
                              1
                            ),
                            _c(
                              "div",
                              { staticClass: "mt-n1 d-flex align-center" },
                              [
                                _c("v-avatar", {
                                  staticClass: "mr-1",
                                  attrs: { color: "error", size: "12" },
                                }),
                                _c(
                                  "span",
                                  {
                                    staticClass: "mx-2 text-h6 grey-700--text",
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$fmt.integer(
                                          _vm.currentItem.file_count -
                                            _vm.currentItem.ok_count
                                        )
                                      )
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "span",
                                  { staticClass: "body-1 grey-700--text" },
                                  [_vm._v("incidencias")]
                                ),
                              ],
                              1
                            ),
                            _c(
                              "div",
                              { staticClass: "mt-n1 d-flex align-center" },
                              [
                                _c("v-avatar", {
                                  staticClass: "mr-1",
                                  attrs: { color: "error", size: "12" },
                                }),
                                _c(
                                  "span",
                                  {
                                    staticClass: "mx-2 text-h6 grey-700--text",
                                  },
                                  [
                                    _vm._v(
                                      "$ " +
                                        _vm._s(
                                          _vm.$fmt.integer(
                                            _vm.currentItem.failed_amount
                                          )
                                        )
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "span",
                                  { staticClass: "body-1 grey-700--text" },
                                  [_vm._v("diferencias absolutas de monto")]
                                ),
                              ],
                              1
                            ),
                            _c(
                              "div",
                              { staticClass: "mt-n1 d-flex align-center" },
                              [
                                _c("v-avatar", {
                                  staticClass: "mr-1",
                                  attrs: { color: "error", size: "12" },
                                }),
                                _c(
                                  "span",
                                  {
                                    staticClass: "mx-2 text-h6 grey-700--text",
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$fmt.integer(
                                          _vm.currentItem.axt_duplicated_count
                                        )
                                      )
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "span",
                                  { staticClass: "body-1 grey-700--text" },
                                  [_vm._v("documentos duplicados en Factura X")]
                                ),
                              ],
                              1
                            ),
                          ]),
                          _c("v-divider", {
                            staticClass: "my-4 grey-200",
                            staticStyle: { "max-height": "25px !important" },
                            attrs: { vertical: "" },
                          }),
                          _c("v-col", { attrs: { cols: "1" } }),
                          _c(
                            "v-col",
                            {
                              staticClass: "px-3 mt-2 text-right",
                              attrs: { cols: "5" },
                            },
                            [
                              _c(
                                "span",
                                { staticClass: "mr-1 text-h4 grey-700--text" },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$fmt.integer(_vm.currentItem.db_count)
                                    )
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "span",
                                { staticClass: "body-1 grey-700--text" },
                                [_vm._v("documentos en Factura X")]
                              ),
                              _c("div", { staticClass: "mt-11" }, [
                                _c(
                                  "span",
                                  {
                                    staticClass:
                                      "body-1 error--text font-weight-semibold",
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$fmt.integer(
                                          ((_vm.currentItem.file_count -
                                            _vm.currentItem.ok_count) *
                                            100) /
                                            _vm.currentItem.file_count
                                        )
                                      ) + "%"
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "span",
                                  { staticClass: "body-1 grey-700--text" },
                                  [_vm._v("de total")]
                                ),
                              ]),
                            ]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm.hasFindingsSummary
                    ? [
                        _c("v-divider"),
                        _c(
                          "v-col",
                          { staticClass: "pl-5 pr-6" },
                          [
                            _c(
                              "span",
                              {
                                staticClass:
                                  "d-block mt-3 grey-700--text subtitle-2 font-weight-semibold",
                              },
                              [_vm._v("Resumen de hallazgos")]
                            ),
                            _vm.findingsSummary.length
                              ? [
                                  _c(
                                    "v-row",
                                    {
                                      staticClass: "mt-2",
                                      attrs: { "no-gutters": "" },
                                    },
                                    [
                                      _c(
                                        "v-col",
                                        {
                                          staticClass: "px-2 py-0",
                                          attrs: { cols: "3" },
                                        },
                                        [
                                          _c(
                                            "span",
                                            {
                                              staticClass:
                                                "body-2 grey-500--text",
                                            },
                                            [_vm._v("En Factura X")]
                                          ),
                                        ]
                                      ),
                                      _c(
                                        "v-col",
                                        {
                                          staticClass: "px-2 py-0",
                                          attrs: { cols: "2" },
                                        },
                                        [
                                          _c(
                                            "span",
                                            {
                                              staticClass:
                                                "body-2 grey-500--text",
                                            },
                                            [
                                              _vm._v(
                                                "En " +
                                                  _vm._s(_vm.$t("generals.SII"))
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                      _c(
                                        "v-col",
                                        {
                                          staticClass: "px-2 py-0 text-end",
                                          attrs: { cols: "2" },
                                        },
                                        [
                                          _c(
                                            "span",
                                            {
                                              staticClass:
                                                "body-2 grey-500--text",
                                            },
                                            [_vm._v("Cantidad")]
                                          ),
                                        ]
                                      ),
                                      _c(
                                        "v-col",
                                        {
                                          staticClass: "px-2 py-0",
                                          attrs: { cols: "5" },
                                        },
                                        [
                                          _c(
                                            "span",
                                            {
                                              staticClass:
                                                "body-2 grey-500--text",
                                            },
                                            [_vm._v("Acción recomendada")]
                                          ),
                                        ]
                                      ),
                                    ],
                                    1
                                  ),
                                  _c("v-divider", { staticClass: "my-2" }),
                                  _vm._l(
                                    _vm.findingsSummary,
                                    function (finding) {
                                      return _c(
                                        "v-row",
                                        {
                                          key: finding.counter,
                                          staticClass: "mb-2",
                                          attrs: { "no-gutters": "" },
                                        },
                                        [
                                          _c(
                                            "v-col",
                                            {
                                              staticClass: "px-2 py-0",
                                              attrs: { cols: "3" },
                                            },
                                            [
                                              _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "body-2 grey-700--text",
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(finding.platform)
                                                  ),
                                                ]
                                              ),
                                            ]
                                          ),
                                          _c(
                                            "v-col",
                                            {
                                              staticClass: "px-2 py-0",
                                              attrs: { cols: "2" },
                                            },
                                            [
                                              _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "body-2 grey-700--text",
                                                },
                                                [_vm._v(_vm._s(finding.agency))]
                                              ),
                                            ]
                                          ),
                                          _c(
                                            "v-col",
                                            {
                                              staticClass: "px-2 py-0 text-end",
                                              attrs: { cols: "2" },
                                            },
                                            [
                                              _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "body-2 grey-700--text font-weight-semibold",
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$fmt.integer(
                                                        finding.count
                                                      )
                                                    )
                                                  ),
                                                ]
                                              ),
                                            ]
                                          ),
                                          _c(
                                            "v-col",
                                            {
                                              staticClass: "px-2 py-0",
                                              attrs: { cols: "5" },
                                            },
                                            [
                                              _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "body-2 grey-700--text",
                                                },
                                                [_vm._v(_vm._s(finding.action))]
                                              ),
                                            ]
                                          ),
                                        ],
                                        1
                                      )
                                    }
                                  ),
                                ]
                              : _c(
                                  "span",
                                  {
                                    staticClass:
                                      "d-block mt-2 body-2 grey-500--text font-italic",
                                  },
                                  [_vm._v(_vm._s(_vm.findingsEmptyMessage))]
                                ),
                          ],
                          2
                        ),
                      ]
                    : _vm._e(),
                ],
                2
              ),
              _c("v-divider"),
              _c(
                "v-card-actions",
                { staticClass: "py-4 px-5" },
                [
                  _c("v-spacer"),
                  !_vm.hasFindingsSummary
                    ? _c(
                        "v-btn",
                        {
                          attrs: {
                            outlined: "",
                            color: "grey-700",
                            loading: _vm.loadingExport,
                          },
                          on: {
                            click: function ($event) {
                              return _vm.download(
                                _vm.currentItem.id,
                                _vm.currentItem.filename
                              )
                            },
                          },
                        },
                        [_vm._v("Exportar registros")]
                      )
                    : _vm._e(),
                  _vm.hasFindingsSummary
                    ? [
                        _c(
                          "v-btn",
                          {
                            attrs: {
                              outlined: "",
                              color: "grey-700",
                              loading:
                                _vm.loadingDownload === _vm.findingsFormat,
                            },
                            on: {
                              click: function ($event) {
                                return _vm.downloadFindings(_vm.currentItem)
                              },
                            },
                          },
                          [_vm._v("Hallazgos")]
                        ),
                        _c(
                          "v-btn",
                          {
                            attrs: {
                              outlined: "",
                              color: "grey-700",
                              loading:
                                _vm.loadingDownload === _vm.sourceFileFormat,
                            },
                            on: {
                              click: function ($event) {
                                return _vm.downloadSourceFile(_vm.currentItem)
                              },
                            },
                          },
                          [_vm._v("Archivo original")]
                        ),
                      ]
                    : _vm._e(),
                  _c(
                    "v-btn",
                    {
                      attrs: { color: "grey-900" },
                      on: {
                        click: function ($event) {
                          _vm.dialogDetail = false
                        },
                      },
                    },
                    [_vm._v("Aceptar")]
                  ),
                ],
                2
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }